export function setShowForm(formModelJson, taskFormPropety){
    let showForm = {
        column:[],
        submitBtn: false,
        emptyBtn: false
    }
    for(let i = 0; i < formModelJson.column.length; i++){
        for(let j = 0; j < taskFormPropety.length; j++){
            if(taskFormPropety[j].id === 'verifyFlag'){
                break
            }
            if(formModelJson.column[i].prop === taskFormPropety[j].id){
                showForm.column.push(formModelJson.column[i])
            }
        }
    }
    for(let i = 0; i < showForm.column.length; i++){
        if(showForm.column[i].prop === 'verifyFlag')
            continue
        for(let j = 0; j < taskFormPropety.length; j++){
            if(showForm.column[i].prop === taskFormPropety[j].id){
                if(taskFormPropety[j].required === true){
                    showForm.column[i].required = true
                    showForm.column[i].rules = {
                        required: true,
                        message: "请选择" + showForm.column[i].label
                    }
                }
                if(taskFormPropety[j].readable && !taskFormPropety[j].writable){
                    showForm.column[i].disabled = true
                }
                break
            }

        }
    }
    return showForm
}

export function doValidBeforeAudit(http, url, postParams, confirmInfo, message) {
    http.post(url, postParams).then(response => {
        if(response.code === 200){
            console.log('doValidBeforeAudit')
            console.log(response)
            let formModelJson = response.data.formModelJsonList[0]
            let taskFormPropety = response.data.taskFormPropertyList
            confirmInfo.options = setShowForm(formModelJson, taskFormPropety)
            console.log(confirmInfo.options)
            confirmInfo.confirmVisible = true
        }else{
            message.error(response.code + response.msg)
        }
    }).catch(err => {
        if(err.code === 1101){
            message.info(err.msg)
        }else {
            message.error(err.msg)
        }

    })
}

export function batchAuditFunc(conf, rows, message) {
    console.log('batchAuditFunc')
    console.log(conf.mainTable.table.paging.total)
    if(conf.mainTable.table.paging.total === 0){
        message.info('当前无需要审批的流程')
        return false
    }
    if(rows.length === 0){
        message.info('请先选择记录')
        return false
    }else if(rows.length > 1){
        let firstRow = rows[0]
        for(let i = 1; i < rows.length; i++){
            if(firstRow.awardPrizeName !== rows[i].awardPrizeName){
                message.info("请选择相同名称的参评记录")
                return false
            }

        }
    }
    return true
}